"use client";

import { Award, Share2, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Efficiency() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    icon: Award,
    title: "Engenharia de Topo",
    description: "Sistemas de pulverização de alta precisão, desenvolvidos para garantir eficiência máxima e reduzir desperdícios operacionais.",
    featured: false
  }, {
    icon: Users,
    title: "Suporte Especializado",
    description: "Representantes exclusivos da Spraying Systems Co. desde 1993, oferecendo consultoria técnica dedicada ao seu setor.",
    featured: true
  }, {
    icon: Share2,
    title: "Soluções Integradas",
    description: "Implementamos tecnologias de controlo avançado que otimizam processos industriais e garantem resultados consistentes.",
    featured: false
  }];
  return <section data-section-id="7672" id="efficiencysafetymetrics" className="bg-background py-24 md:py-32 font-default">
      <div className="mx-auto max-w-[1240px] px-6 md:px-20">
        {}
        <div ref={ref} className={`mx-auto max-w-[720px] text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-serif text-foreground text-[clamp(2.1rem,4vw,3.5rem)] font-medium leading-[1.08] tracking-[-0.02em]">
            Excelência em{" "}
            <em className="font-light italic">Pulverização</em>.
          </h2>
          <p className="mt-6 text-muted-foreground text-[clamp(1.0625rem,1.15vw,1.25rem)] leading-[1.6]">
            A Eurocontrol combina décadas de experiência técnica com a inovação da Spraying Systems Co. para elevar a produtividade da sua indústria.
          </p>
        </div>

        {}
        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`group relative flex flex-col rounded-lg bg-card border border-border p-8 shadow-lg transition-all duration-[280ms] ease-out hover:-translate-y-1 hover:shadow-xl ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: isVisible ? `${i * 90}ms` : "0ms",
            boxShadow: "inset 0 1px 0 hsl(0 0% 100% / 0.5), 0 1px 0 var(--border), 0 24px 48px -32px hsl(220 22% 6% / 0.12)"
          }}>
                {feature.featured && <Badge className="absolute top-5 right-5 bg-primary text-primary-foreground rounded-md px-3 py-1 text-xs font-semibold">
                    Destaque
                  </Badge>}

                {}
                <div className={`flex h-16 w-16 items-center justify-center rounded-md ${feature.featured ? "bg-primary" : "bg-accent"}`}>
                  <Icon className={`h-7 w-7 ${feature.featured ? "text-primary-foreground" : "text-primary"}`} strokeWidth={1.75} />
                </div>

                {}
                <h3 className="mt-8 font-default text-foreground text-[clamp(1.25rem,1.6vw,1.5rem)] font-semibold leading-[1.25] tracking-[-0.01em]">
                  {feature.title}
                </h3>

                {}
                <p className="mt-4 flex-1 text-muted-foreground text-base leading-[1.65]">
                  {feature.description}
                </p>

                {}
                <div className="mt-8">
                  <Button asChild variant="link" className="h-auto p-0 text-primary hover:no-underline font-semibold">
                    <Link to="/ProductsPage" className="inline-flex items-center gap-1">
                      <span>Saber mais</span>
                      <span aria-hidden="true" className="inline-block transition-transform duration-[260ms] ease-out group-hover:translate-x-1">
                        →
                      </span>
                    </Link>
                  </Button>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}